/* eslint-disable react-hooks/exhaustive-deps */
import {
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Table,
  FormControlLabel,
  Switch,
  Tooltip,
} from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { Estabelecimento as _EstabelecimentoSaida } from "src/framework/components/forms/inputs/InputSelectEstabelecimentos";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import { InputSwitch } from "src/framework/components/forms/inputs/InputSwitch";
import { Componente, Estabelecimento } from "../../types";
import { InputInteger } from "src/framework/components/forms/inputs/InputInteger";
import { Formater, TypeRecords } from "src/framework/commons/Formater";

export interface EstabelecimentoSaidaProperties {
  list: Estabelecimento[];
  listEstabelecimento: any;
  listComponente: any;
  onChange: (list: Estabelecimento[]) => void;
}

const EstabelecimentoSaida: FC<EstabelecimentoSaidaProperties> = ({
  list = [],
  listEstabelecimento = [],
  listComponente = [],
  onChange = () => { },
}) => {
  const [listState, setListState] = useState<Estabelecimento[]>([]);


  useEffect(() => {
    setListState(prepareList());
  }, []);

  useEffect(() => {
    setListState(prepareList())
  }, [list]);


  useEffect(() => {

    setListState(prepareList())

  }, [listEstabelecimento])


  const prepareList = () => {
    const _list = listEstabelecimento.map(
      (_estabelecimentoSaida: _EstabelecimentoSaida) => {
        const idx = list.findIndex(
          (estabelecimento) =>
            _estabelecimentoSaida.id === estabelecimento.estabelecimento_id
        );
        if (idx > -1) {
          return {
            estabelecimento_id: _estabelecimentoSaida.id,
            minimo: list[idx].minimo,
            considerar_calculo: list[idx].considerar_calculo,
            componente_substituto_id: list[idx].componente_substituto_id,
            expedicao: list[idx].expedicao,
            minimo_funil: list[idx].minimo_funil,
          };
        }
        return {
          estabelecimento_id: _estabelecimentoSaida.id,
          minimo_funil: 0,
          minimo: 0,
          considerar_calculo: false,
          expedicao: true,
          componente_substituto_id: "",
        };
      }
    );

    return _list;
  }


  const handleChangeSwitch = (idx: number, value: boolean) => {
    if (idx > -1) {
      listState[idx].considerar_calculo = value;
      setListState([...listState]);
      onChange(listState);
    }
  };

  const handleChangeSwitchExpedicao = (idx: number, value: boolean) => {
    if (idx > -1) {
      listState[idx].expedicao = value;
      setListState([...listState]);
      onChange(listState);
    }
  };

  const handleChange = (idx: number, estabelecimento: Estabelecimento) => {
    if (idx > -1) {
      listState[idx] = estabelecimento;
      setListState([...listState]);
      onChange(listState);
    }
  };

  return (
    <div className="x12">
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Estabelecimento</TableCell>
              <TableCell>Quantidade mínima</TableCell>
              <TableCell>Quantidade mínima funíl</TableCell>
              <TableCell>Componente subistituto</TableCell>
              <TableCell align={"center"}>Expedição</TableCell>
              <TableCell align={"center"}>Considerar cálculo</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {listEstabelecimento.map(
              (_estabelecimento: _EstabelecimentoSaida) => {

                const estabelecimento: any = listState.find((e) => {
                  return e.estabelecimento_id === _estabelecimento.id;
                });

                const idx: number = listState.findIndex((e) => {
                  return e.estabelecimento_id === _estabelecimento.id;
                });

                if (!estabelecimento) {
                  return "";
                }

                return (
                  <TableRow
                    key={`estabelecimento-saida-${idx}-${_estabelecimento?.id}`}
                    title={estabelecimento.ultima_atualizacao_minimo_funil}
                  >
                    <TableCell width={"40px"}>{_estabelecimento?.id}</TableCell>
                    <TableCell width={"20%"}>
                      <InputInteger
                        fullWidth={true}
                        name={`minimo-${idx}`}
                        label={"Mínimo"}
                        value={listState[idx]["minimo"].toString()}
                        maxLength={9}
                        onChangeValue={(e: any, value: any) => {
                          const estabelecimento: Estabelecimento = list[idx];
                          if (estabelecimento) {
                            estabelecimento.minimo = parseInt(
                              value.toString().replace(/\./, "")
                            );
                            handleChange(idx, estabelecimento);
                          }
                        }}
                      />
                    </TableCell>
                    <Tooltip
                      title={`Última atualização: ${Formater.toString(
                        estabelecimento.ultima_atualizacao_minimo_funil,
                        TypeRecords.DATE_TIME
                      )}`}
                    >
                      <TableCell>
                        {listState[idx]?.minimo_funil || " - "}
                      </TableCell>
                    </Tooltip>
                    <TableCell>
                      <InputSelectSimple
                        label={"Componentes"}
                        value={listState[idx]?.componente_substituto_id}
                        list={listComponente.map((componente: Componente) => {
                          return {
                            text: componente.modelo,
                            value: componente.id,
                          };
                        })}
                        onChange={(
                          event: React.ChangeEvent<{ value: string }>
                        ) => {
                          const estabelecimento: Estabelecimento =
                            listState[idx];

                          if (estabelecimento && typeof event === "number") {
                            estabelecimento.componente_substituto_id =
                              parseInt(event);
                          }

                          if (estabelecimento && typeof event === "string") {
                            estabelecimento.componente_substituto_id = 0;
                          }

                          handleChange(idx, estabelecimento);
                        }}
                      />
                    </TableCell>
                    <TableCell width={"160px"} align={"center"}>
                      <InputSwitch
                        value={listState[idx]?.expedicao}
                        onChangeValue={(value: boolean, name: string) => {
                          handleChangeSwitchExpedicao(idx, value);
                        }}
                      />
                    </TableCell>
                    <TableCell width={"160px"} align={"center"}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={
                              listState[idx]?.considerar_calculo || false
                            }
                            onChange={(
                              event: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              handleChangeSwitch(idx, event.target.checked);
                            }}
                            name=""
                            color="primary"
                          />
                        }
                        label=""
                      />
                    </TableCell>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export { EstabelecimentoSaida };
